import { Routes } from '@angular/router';
import { FirstComponent } from './first/first.component';
import { SecondComponent } from './second/second.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ProfileComponent } from './auth/components/profile/profile.component';
import { authGuard, publicOnlyGuard } from './auth/guards/auth.guard';
import { DaySliderExampleComponent } from './booking/booking-container/calendar/day-slider-example.component';
import { StartSlotPickerComponent } from './booking/booking-container/start-slot-picker/start-slot-picker.component';
import { BookingContainerComponent } from './booking/booking-container/booking-container.component';
import { LoginComponent } from './auth/components/login/login.component';
import { AppRoutes } from './core/constants/routes';
import { AuthCallbackComponent } from './auth/components/auth-callback/auth-callback.component';
import { adminGuard } from './core/guards/admin.guard';
import { environment } from '../environments/environment';


// Create dev routes conditionally based on environment
const devRoutes = environment.enableDevTools ? [
  {
    path: 'dev',
    loadChildren: () => import('./dev/dev.routes').then(m => m.DEV_ROUTES),
    canActivate: [authGuard],
    title: 'Component Showcase'
  }
] : [];

export const routes: Routes = [
  // { path: AppRoutes.HOME, component: HomeComponent, title: 'Home' },
  { path: AppRoutes.HOME, redirectTo: AppRoutes.BOOK, pathMatch: 'full', title: 'Startseite' },
  { path: AppRoutes.LOGIN, component: LoginComponent, title: 'Anmelden', canActivate: [publicOnlyGuard] },
  { path: AppRoutes.PROFILE, component: ProfileComponent, title: 'Profil', canActivate: [authGuard] },
  // {
  //   path: AppRoutes.BOOKINGS,
  //   loadComponent: () => import('./features/my-bookings/my-bookings.component')
  //     .then(m => m.MyBookingsComponent),
  //   canActivate: [authGuard],
  //   title: 'My Bookings'
  // },
  { path: 'first', component: FirstComponent, title: 'First', canActivate: [authGuard] },
  { path: 'day-slider', component: DaySliderExampleComponent, title: 'Day Slider Example', canActivate: [authGuard] },
  { path: 'slots', component: StartSlotPickerComponent, title: 'Courts', canActivate: [authGuard] },
  { path: AppRoutes.BOOK, component: BookingContainerComponent, title: 'Buchen', canActivate: [authGuard] },
  {
    path: 'second',
    component: SecondComponent,
    title: 'Second',
    canActivate: [authGuard],
       // children: [
    //   {
    //     path: 'child-a', // child route path
    //     title: 'Child A',
    //     component: ChildAComponent, // child route component that the router renders
    //   },
    //   {
    //     path: 'child-b',
    //     title: 'Child B',
    //     component: ChildBComponent, // another child route component that the router renders
    //   },
    // ],
  },
  { path: AppRoutes.SIGNUP, redirectTo: 'login?mode=signup', pathMatch: 'full' },
  { 
    path: AppRoutes.AUTH_CALLBACK, 
    component: AuthCallbackComponent 
  },
  {
    path: AppRoutes.BOOKINGS,
    loadChildren: () => import('./booking/booking-history/booking-history.routes').then(m => m.BOOKING_HISTORY_ROUTES)
  },
  {
    path: AppRoutes.MY_INVOICES,
    loadChildren: () =>
      import('./features/my-invoices/my-invoices.routes').then(
        (m) => m.MY_INVOICES_ROUTES,
      ),
  },
  {
    path: AppRoutes.VOUCHERS,
    loadChildren: () => import('./features/vouchers/vouchers.routes').then(m => m.VOUCHER_ROUTES)
  },
  {
    path: AppRoutes.COURSE_LIST,
    loadChildren: () => import('./features/courses/courses.routes').then(m => m.COURSES_ROUTES),
    canActivate: [authGuard],
    title: 'Kurse'
  },
  {
    path: AppRoutes.SUBSCRIPTIONS,
    loadChildren: () => import('./features/subscriptions/subscriptions.routes').then(m => m.SUBSCRIPTION_ROUTES),
    canActivate: [authGuard],
    title: 'Abonnements'
  },
  {
    path: AppRoutes.ADMIN,
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES),
    canActivate: [adminGuard],
    title: 'Admin'
  },
  {
    path: AppRoutes.CLUBS,
    loadChildren: () => import('./features/clubs/clubs.routes').then(m => m.CLUBS_ROUTES),
    title: 'Clubs'
  },
  // Development routes - only included in development builds
  ...devRoutes,
  { path: '**', component: NotFoundComponent, title: 'Seite nicht gefunden' }, // Wildcard route for 404 page
];
